import { Err, Ok, Result } from 'ts-res';
import { SdkLanguageType } from 'src/constants';
import { KameleoonError } from 'src/kameleoonError';
import { Utilities } from 'src/utilities';
import { ExternalPackageInfoType } from 'src/sdkInfoTypes';
import { EvaluationDataType, VersionMatchType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';

export class SdkLanguage implements ICondition {
  private sdkLanguage?: SdkLanguageType | null;
  private conditionValue?: string | null;
  private versionMatchType?: VersionMatchType | null;

  constructor({ sdkLanguage, version, versionMatchType }: ConditionDataType) {
    this.sdkLanguage = sdkLanguage;
    this.conditionValue = version;
    this.versionMatchType = versionMatchType;
  }

  public evaluate({
    sdkInfo,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    return this.checkCondition(sdkInfo);
  }

  private checkCondition(
    sdkInfo: ExternalPackageInfoType,
  ): Result<boolean, KameleoonError> {
    const { type: sdkType, version } = sdkInfo;

    if (!this.sdkLanguage) {
      return Ok(false);
    }

    if (typeof this.conditionValue !== 'string') {
      return Ok(sdkType === this.sdkLanguage);
    }

    if (!this.versionMatchType) {
      return Ok(false);
    }

    if (sdkType !== this.sdkLanguage) {
      return Ok(false);
    }

    const result = Utilities.compareSemVer({
      version,
      compareVersion: this.conditionValue,
      operator: this.versionMatchType,
    });

    if (!result.ok) {
      return Err(result.error);
    }

    return Ok(result.data);
  }
}
